import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../axiosConfig";
import WIPHeader from "../components/WIP-Herder";
import DataTable from "react-data-table-component";

const BoxRMShortage = () => {
  const [shortageData, setShortageData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // ** Check Session & Redirect if Not Authenticated **
  const checkAuth = useCallback(() => {
    const authData = sessionStorage.getItem("auth");
    if (!authData) {
      window.location.href = "/wip-login"; // Redirect to login
      return;
    }

    const { loggedIn, expiryTime } = JSON.parse(authData);
    if (!loggedIn || Date.now() > expiryTime) {
      sessionStorage.removeItem("auth"); // Clear session
      window.location.href = "/wip-login"; // Redirect to login
    }
  }, []);

  // ** Fetch Box RM Shortage data **
  const fetchShortageData = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/BOXRMshortage");
      setShortageData(response.data);
    } catch (error) {
      console.error("Error fetching shortage data:", error);
    }
  }, []);

  // ** Run Session Check & Fetch Data **
  useEffect(() => {
    checkAuth(); // Initial session check
    fetchShortageData(); // Fetch data

    const interval = setInterval(checkAuth, 1000); // Check session every second
    return () => clearInterval(interval); // Cleanup on component unmount
  }, [checkAuth, fetchShortageData]);

  // ** Search Filter **
  const filteredData = shortageData.filter((row) =>
    row["ITEM_NAME"]?.toLowerCase().includes(searchTerm)
  );

  // ** DataTable Columns **
  const columns = [
    { name: "Sr No", selector: (_, index) => index + 1, sortable: true, width: "80px" },
    { name: "Item Name", selector: (row) => row.ITEM_NAME || "N/A", sortable: true },
    { name: "Barcode", selector: (row) => row.BARCODE || "N/A", sortable: true },
    { name: "Item Description", selector: (row) =>(
      <span
      data-toggle="tooltip"
      title={row.ITEM_DESCRIPTION}
      >
        {row.ITEM_DESCRIPTION || "N/A"}
      </span>
    ), sortable: true },
    { name: "Size", selector: (row) => row.SIZE || "N/A", sortable: true },
    { name: "Closing Stock", selector: (row) => row.CLOSING_STOCK || "0", sortable: true }
  ];

  return (
    <>
      <WIPHeader />
      <div className="p-4 mt-4">
        <h1 className="">Inventory</h1>

        <div className="d-flex justify-content-between align-items-center mt-4">
          <button className="btn btn-secondary btn-sm" onClick={() => window.history.back()}>
            &#8592; Back
          </button>
          <input
            type="text"
            className="form-control w-25"
            placeholder="Search Item Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
          />
        </div>

        {/* ✅ DataTable Integration */}
        <div className="mt-4">
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
          />
        </div>
      </div>
    </>
  );
};

export default BoxRMShortage;
